<template lang="html">
  <div class="i-cell" @click="handleClick">
    <div class="i-cell-left">
      <div class="i-cell-left-title"><slot></slot></div>
      <div v-if="desc" class="i-cell-left-desc">{{desc}}</div>
    </div>
    <div class="i-cell-right">
      <span v-if="level">{{level}}</span>
      <i class="cubeic-arrow"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'i-cell',
  props: {
    desc: {
      type: String,
      default: null,
    },
    level: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.i-cell {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 16px;
  line-height: 18px;
  align-items: center;
  border-bottom: 1px solid #f5f5f5;
  .i-cell-left {
    flex: .8;
    overflow: hidden;
    .i-cell-left-title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .i-cell-left-desc {
      font-size: 11px;
      color: #999;
    }
  }
  .i-cell-right {
    text-align: right;
    flex: .2;
    span {
      font-size: 15px;
      color: #ff9800;
    }
    i {
      color: #e0e0e0;
    }
  }
}
</style>
